"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.2.4'] && _();
}
catch (e) { }
